
















import Vue, { PropType } from "vue";

import { Language } from "@/store/types";

import Prism from "vue-prism-component";
import AnchorLink from "../misc/AnchorLink.vue";
import LanguageIcon from "../misc/LanguageIcon.vue";
import WarningMessage from "../misc/WarningMessage.vue";

export default Vue.extend({
  name: "LanguageCard",
  components: {
    Prism,
    AnchorLink,
    WarningMessage,
    LanguageIcon,
  },
  props: {
    language: Object as PropType<Language>,
    code: {
      type: String,
      required: false,
    },
  },
});
